import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    orgCard: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    header: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    paginationContainer: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center"
    },
    cardInfo: {
        flexDirection: "column",
        flex: 1
    },
    jumpInputContainer: {
        justifyContent: "center"
    },
    headerButtonsContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    cardContent: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    },
    jumpContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    cardActions: {
        flexDirection: "row"
    },
    jumpInput: {
        borderWidth: 1,
        height: 40,
        width: 60
    },
    searchContainer: {
    },
    scrollContent: {
    },
    listContainer: {
        flex: 1
    },
    profileImage: {
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
